export default "https://statics.cloudfastin.top/static/v1.27.38.3-s.dispute.2/store/images/eBayebay.png?7db1b39c3006ea785e042303cf98a4f8";